import {Component, Input, OnInit} from '@angular/core';
import StyleFormatter from '../../../utils/style-formatter';

@Component({
  selector: 'nodes-summary',
  templateUrl: './nodes-summary.component.html',
  styleUrls: ['./nodes-summary.component.scss']
})
export class NodesSummaryComponent implements OnInit {

  styleFormatter;

  @Input() selection: any;

  isCollapsed = true;

  constructor() {
    this.styleFormatter = StyleFormatter;
  }

  ngOnInit(): void {
  }

  nodeOperativeStateToColor(status): any {
    switch (status) {
      case 0:
        return {c2n: 'red', n2c: 'red', n2rR: 'red', n2rN: 'red'};
      case 1:
        return {c2n: 'red', n2c: 'red', n2rR: 'red', n2rN: 'green'};
      case 2:
        return {c2n: 'red', n2c: 'red', n2rR: 'green', n2rN: 'red'};
      case 3:
        return {c2n: 'red', n2c: 'red', n2rR: 'green', n2rN: 'green'};
      case 4:
        return {c2n: 'red', n2c: 'green', n2rR: 'red', n2rN: 'red'};
      case 5:
        return {c2n: 'red', n2c: 'green', n2rR: 'red', n2rN: 'green'};
      case 6:
        return {c2n: 'red', n2c: 'green', n2rR: 'green', n2rN: 'red'};
      case 7:
        return {c2n: 'red', n2c: 'green', n2rR: 'green', n2rN: 'green'};
      case 8:
        return {c2n: 'green', n2c: 'red', n2rR: 'red', n2rN: 'red'};
      case 9:
        return {c2n: 'green', n2c: 'red', n2rR: 'red', n2rN: 'green'};
      case 10:
        return {c2n: 'green', n2c: 'red', n2rR: 'green', n2rN: 'red'};
      case 11:
        return {c2n: 'green', n2c: 'red', n2rR: 'green', n2rN: 'green'};
      case 12:
        return {c2n: 'green', n2c: 'green', n2rR: 'red', n2rN: 'red'};
      case 13:
        return {c2n: 'green', n2c: 'green', n2rR: 'red', n2rN: 'green'};
      case 14:
        return {c2n: 'green', n2c: 'green', n2rR: 'green', n2rN: 'red'};
      case 15:
        return {c2n: 'green', n2c: 'green', n2rR: 'green', n2rN: 'green'};

      case 94:
        return {c2n: 'red', n2c: 'red', n2rR: 'red', n2rN: 'red'};
      default:
        return {c2n: 'grey', n2c: 'grey', n2rR: 'grey', n2rN: 'grey'};
    }
  }
}
